import { InitialState } from './voucher.types'

export const initialState: InitialState = {
  status: 'idle',
  active: [],
  disabled: [],
}
